import React from 'react';

import CreateEgrnPage from '@/features/egrn/pages/create-egrn.page';

const CreateEgrnRoute = () => {
  return <CreateEgrnPage />;
};

export default CreateEgrnRoute;
